// 导入axios实例
import httpRequest from "@/request/index"
import base from "@/request/base"
import qs from "qs" //
// 获取登录信息
export function gameLogin(params) {
  return httpRequest({
    url: `${base.url}/web/login/account`,
    method: "post",
    data: qs.stringify(params),
  })
}
//获取游戏列表
export function getList() {
  return httpRequest({
    url: `${base.url}/v3/pay/official/list`,
    method: "get",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}
//发送短信（登录用）
export function sms(params) {
  return httpRequest({
    url: `${base.url}/web/send/sms`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}
// 短信验证码登录
export function smsLogin(params) {
  return httpRequest({
    url: `${base.url}/web/login/sms`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 登录后初始化
export function init(params) {
  return httpRequest({
    url: `${base.url}/web/qy/user`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 获取游戏列表
export function getGameList() {
  return httpRequest({
    url: `${base.url}/web/qy/game`,
    method: "get",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 获取页签
export function getTab(params) {
  return httpRequest({
    url: `${base.url}/web/qy/tab`,
    params,
    method: "get",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 获取礼包
export function getGiftList(params) {
  return httpRequest({
    url: `${base.url}/web/qy/pack`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 获取用户信息
export function getUserInfo() {
  return httpRequest({
    url: `${base.url}/web/qy/user_info`,
    method: "get",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 获取角色列表
export function getRoleList(params) {
  return httpRequest({
    url: `${base.url}/web/qy/role`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 登录后初始化
export function receiveGood(params) {
  return httpRequest({
    url: `${base.url}/web/qy/send_pack`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 填写专属VIP客服电话
export function setUserTel(params) {
  return httpRequest({
    url: `${base.url}/web/qy/user_tel`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 获取青钻明细
export function getCoinList(params) {
  return httpRequest({
    url: `${base.url}/web/qy/user_coin`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 获取青宇商店商品列表
export function getGoodList(params) {
  return httpRequest({
    url: `${base.url}/web/qy/goods`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 获取收货地址列表
export function getAddressList(params) {
  return httpRequest({
    url: `${base.url}/web/qy/address`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 添加收货地址
export function addAddressApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/address`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 编辑收货地址
export function editAddressApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/address_edit`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 删除收货地址
export function deleteAddressApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/address_del`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 成长值明细列表
export function getPointList(params) {
  return httpRequest({
    url: `${base.url}/web/qy/user_points`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 平台规则
export function getRules(params) {
  return httpRequest({
    url: `${base.url}/web/qy/rule`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 轮播图
export function getSwiperImg(params) {
  return httpRequest({
    url: `${base.url}/web/qy/ad`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 商品兑换
export function goodsPay(params) {
  return httpRequest({
    url: `${base.url}/web/qy/goods_pay`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 兑换记录-青宇商店
export function getUserOrderApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/user_order`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 兑换记录-游戏礼包
export function getUserPackApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/user_pack`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 物流查询
export function getLogisticsApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/logistics`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 问题记录
export function getMajorApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/major`,
    method: "get",
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 提交问题
export function submitMajorApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/major`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 回复问题
export function majorReplyApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/major_reply`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 回复问题
export function majorStatusApi(params) {
  return httpRequest({
    url: `${base.url}/web/qy/major_status`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
}

// 第三方跳转登录
export function getPayForOtherLogin(params) {
  return httpRequest({
    url: `${base.url}/web/config/jump/token/${params.token}`,
    method: "get",
  })
}

// 获取静默登录token
export function jumpApi(params, headers) {
  return httpRequest({
    url: `${base.url}/web/qy/config/jump`,
    method: "post",
    data: qs.stringify(params),
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      ...headers
    },
  })
}